import { render, staticRenderFns } from "./MRListPage.vue?vue&type=template&id=7f749320"
import script from "./MRListPage.vue?vue&type=script&lang=ts"
export * from "./MRListPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports